export const stripeUrl = {
    testSecretKeyStripeToken : 'sk_test_51JtmREEAyzfNDyj3LRP2rRDaEDC1o4rpi9Lf9zJYmt3cRUgXI4gcCeFm8ielUcOG9NuQkGKoOsFLuMBYMhpFKSzv00AbeDxW0i',
    testStripePublicKey : 'pk_test_51JtmREEAyzfNDyj3V494hjKXFKrCqRdusSaCwpaHjRmnteRxKrvPr9NG9KeacOj5TlTKjicjv2fOlRC61j8KzWUp00dtvR495o',

    producationSecretKeyStripeToken : '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',
    producationPublicKey : 'pk_live_51JtmREEAyzfNDyj34AWJZ3b12tm9ZuCe1lUzQCCWlvO6ScioSAuOhL9vz7BqrhETfF94SJvVyNeeNoL1Jh4y7GCJ00FEfEAfRI'
}
